import {
	type QueryKey,
	type UseQueryOptions,
	useQuery,
} from '@tanstack/react-query';

import { sleep } from '../../utils/sleep';

export const useTriggerSuspense = (
	queryKey: QueryKey,
	time: number,
	options?: UseQueryOptions<string, Error>,
) => {
	// @ts-expect-error - @tanstack upgrade issue
	return useQuery<string, Error>({
		queryKey,
		queryFn: async (): Promise<string> => {
			await sleep(time);
			return 'fetched';
		},
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnMount: true,
		suspense: true,
		...options,
	});
};
